import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css!';

class SliderMissions {

  constructor(){
    this.component = document.querySelector('[data-component="slider-missions"]');
    this.trigger = document.querySelector('[data-trigger="slider-missions"]');
    this._init();
  }

  _init(){

    if( this.component ){
      this.swiper = null;
        
      const firstImage = this.trigger.querySelector('img');
      if(firstImage){
        firstImage.onload = ()=> {
          if(this.swiper){
            this.swiper.update();
          }
        };
      }

      this.swiper = new Swiper(this.trigger, {
        pagination: {
          el: this.component.querySelector('[data-trigger="slider-missions-pagination"]'),
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: this.component.querySelector('[data-trigger="slider-missions-next"]'),
          prevEl: this.component.querySelector('[data-trigger="slider-missions-prev"]'),
        },
        slidesPerView: 2,
        spaceBetween: 10,
        breakpoints: {
          850: {
            slidesPerView: 1,
          }
        },
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true,
        }
      });
    }
  }
}

export const sliderMissions = new SliderMissions();